import { useEffect, useState } from "react";
import { useAuth } from "../providers/auth";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import ScrollToTop from "../providers/router";
import HeaderOld from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import RotatorDisplay from "./seekerRotator/parts/rotatorDisplay";
import Header from "../components/seeker/details/New_UI/Header/Header";
import { manageConfiguration } from "../data/configuration";
import EmpHeader from "../components/employer/details/New_Ui/Component/Header/EmpHeader_newUI";

/** Image-free placeholder matching EmpHeader height — avoids old-logo flash */
function HeaderShell() {
  return (
    <div
      className="fixed w-full z-50 py-4 p-1 bg-[#E4EBEF]"
      style={{ minHeight: 72 }}
      aria-hidden
    />
  );
}

function IndexPage(props) {
  const location = useLocation();
  const currentPath = location.pathname;
  const { user, userClaims } = useAuth();
  const navigate = useNavigate();
  const [newConfig, setNewConfig] = useState(false);
  const [newEmpConfig, setNewEMPConfig] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchKeyWords, setSearchKeyWords] = useState();

  const claimType = userClaims?.claims?.type;
  const isPublicAuthPath =
    currentPath === "/auth/signin" ||
    currentPath === "/auth/employer" ||
    currentPath.startsWith("/auth/") ||
    currentPath.startsWith("/invitation") ||
    currentPath === "/authaction" ||
    currentPath.startsWith("/social");

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const data = await manageConfiguration();
        if (data[0]?.manage_new_ui) {
          setNewConfig(data[0]?.manage_new_ui);
          setNewEMPConfig(data[0]?.manage_new_ui_employer);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchSkills();
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/") {
      user
        ? navigate("/dashboardinsight/employers&plan", { replace: true })
        : navigate("/auth/signin", { replace: true });
    }
  }, [user, navigate]);

  const renderEmployerHeader = () => {
    if (isPublicAuthPath) return null;

    // Never mount HeaderOld while config/claims are still settling (old UI flash).
    if (loading || !claimType) {
      return <HeaderShell />;
    }

    if (newEmpConfig && claimType === "E") {
      return <EmpHeader />;
    }

    return <HeaderOld />;
  };

  return (
    <>
      {claimType === "S" ? (
        <>
          <ScrollToTop />
          {newConfig ? (
            <>
              {currentPath !== "/email-verification" &&
                currentPath !== "/registration/multifactor-enrollment" &&
                currentPath !== "/auth/signin" && (
                  <Header
                    searchKeyWords={searchKeyWords}
                    setSerachKeyWords={setSearchKeyWords}
                  />
                )}
              <Outlet />
            </>
          ) : (
            <>
              {!loading && <HeaderOld />}
              <main className="clear-both bg-gray-50 min-h-screen">
                <div className="grid grid-cols-12 gap-4 w-full">
                  <div className="xs:hidden sm:hidden md:col-span-4 lg:col-span-4 xl:col-span-4 2xl:col-span-4">
                    {!loading && <RotatorDisplay />}
                  </div>
                  <div className="xs:col-span-12 sm:col-span-12 md:col-span-8 lg:col-span-8 xl:col-span-8 2xl:col-span-8">
                    <Outlet />
                  </div>
                </div>
              </main>
              {!loading && <Footer />}
            </>
          )}
        </>
      ) : (
        <>
          {loading ? (
            <>
              {!isPublicAuthPath && <HeaderShell />}
              <Outlet />
            </>
          ) : newConfig ? (
            <>
              {renderEmployerHeader()}
              <Outlet />
            </>
          ) : (
            <>
              <ScrollToTop />
              {!isPublicAuthPath && <HeaderOld />}
              <Outlet />
              {!isPublicAuthPath && <Footer />}
            </>
          )}
        </>
      )}
    </>
  );
}

export default IndexPage;
